import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "removeSymbols",
    pure: true,
    standalone: false
})
export class RemoveSymbolsPipe implements PipeTransform {
  transform(value: string): any {
    return !value ? "" : value.replace(/[^a-zA-Z0-9]/g, "");
  }
}
